import { Component, app } from "modular-openscriptjs";

const h = app("h");

export default class SliderItem extends Component {
	render(config, ...args) {
		return h._(
			h.div(
				{
					data_slide: `slider-${config.uid}`,
					class: `slide ${config.active ? "active" : ""}`.trim(),
				},
				h.div({ class: "slide-content" }, ...args)
			)
		);
	}
}